<template>
  <div class="home-module">
    <div class="goods-type-title">
      <div class="goods-type-title-left">
        <div class="left-title">{{ title }}</div>
        <div class="right-sub" v-if="showTab">
          <div
            class="right-sub-item"
            :class="active == item.key ? 'activeSty' : ''"
            v-for="(item, index) in tabList"
            :key="index"
            @click="activeType(item.key)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <list :type="active" :num="numMax" :isShowBg="isShowBg"></list>
  </div>
</template>
<script>
import list from "./list";
export default {
  props: {
    title: String,
    showTab: Boolean,
    isShowBg: Boolean,
  },
  data() {
    return {
      active: 6,
      numMax: 100,
      pageNo: 1,
      lists: [],
      hasBoundScroll: false,
      stayTop: false,
      loading: false,
      hasMore: true,
      tabList: [
        {
          title: "精选推荐",
          desc: "精选推荐",
          key: 6,
        },
        {
          title: "自营优品",
          desc: "自营优品",
          key: 3,
        },
        {
          title: "企业网店",
          desc: "企业网店",
          key: 2,
        },
        {
          title: "金牌网店",
          desc: "金牌网店",
          key: 4,
        },
        {
          title: "银牌网店",
          desc: "品质生活",
          key: 5,
        },
        {
          title: "个体网店",
          desc: "猜你喜欢",
          key: 1,
        },
      ],
    };
  },
  components: {
    list,
  },
  created() {
    // if (this.showTab) {
    //   this.active = 2;
    // } else {
    //   this.active = 6;
    // }
  },
  mounted() {
    //this.bindScroll();
  },
  activated() {
    //this.bindScroll();
  },
  destroyed() {
    $(window).unbind("scroll");
  },
  deactivated() {
    $(window).unbind("scroll");
    this.hasBoundScroll = false;
  },
  methods: {
    activeType(type) {
      if (this.active == type) return;
      this.active = type;
    },
  },
};
</script>
<style lang="less" scoped>
.home-module {
  margin-bottom: 107px;
  .goods-type-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 54px;
    .goods-type-title-left {
      display: flex;
      align-items: center;
      .left-title {
        font-size: 35px;
        color: #333333;
        margin-right: 20px;
      }
      .right-sub {
        margin-left: 72px;
        // font-size: 18px;
        // color: #858585;
        display: flex;
        .right-sub-item {
          width: 86px;
          height: 30px;
          border-radius: 15px;
          background: #e5e5e5;
          line-height: 30px;
          text-align: center;
          margin-right: 38px;
          color: #676767;
          font-size: 15px;
          cursor: pointer;
          &:hover {
            background: #ee1c25;
            color: #fff;
          }
        }
        .activeSty {
          background: #ee1c25;
          color: #fff;
        }
      }
    }
    .goods-type-title-right {
      display: flex;
      align-items: center;
      cursor: pointer;
      span {
        color: #858585;
        font-size: 18px;
        margin-right: 10px;
      }
      img {
        width: 12px;
        height: 23px;
      }
    }
  }
  .classify {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    position: relative;
  }

  .type {
    background: #fff;
    position: relative;
    cursor: pointer;
    padding: 10px 0;
    width: 20%;
    text-align: center;

    h4 {
      font-weight: bold;
      font-size: 18px;
    }

    p {
      color: #999;
      line-height: 18px;
    }

    .underline {
      display: none;
      border-bottom: 4px solid #d59b40;
      width: 25px;
      margin: 5px auto 0;
    }

    .border {
      position: absolute;
      right: 1px;
      top: 50%;
      transform: translateY(-50%);
      height: 24px;
      width: 2px;
      background: #000;
    }
  }

  .choose {
    h4,
    p {
      color: #d59b40;
    }

    .underline {
      display: block;
    }
  }

  .fixed {
    position: fixed;
    top: 0;
    width: 1190px;
    z-index: 999;
  }

  .normal {
    position: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?5ce3457e